'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.SVG_ICON_SIZES = void 0;
(function (SVG_ICON_SIZES) {
    SVG_ICON_SIZES["SMALL"] = "small";
    SVG_ICON_SIZES["MEDIUM"] = "medium";
    SVG_ICON_SIZES["LARGE"] = "large";
    SVG_ICON_SIZES["XL"] = "xl";
})(exports.SVG_ICON_SIZES || (exports.SVG_ICON_SIZES = {}));
exports.SVG_ICON_COLORS = void 0;
(function (SVG_ICON_COLORS) {
    SVG_ICON_COLORS["PRIMARY"] = "primary";
    SVG_ICON_COLORS["SECONDARY"] = "secondary";
    SVG_ICON_COLORS["DISABLED"] = "disabled";
    SVG_ICON_COLORS["NEGATIVE"] = "negative";
    SVG_ICON_COLORS["WARNING"] = "warning";
    SVG_ICON_COLORS["POSITIVE"] = "positive";
    SVG_ICON_COLORS["INTERACTIVE"] = "interactive";
    SVG_ICON_COLORS["LIGHT"] = "light";
})(exports.SVG_ICON_COLORS || (exports.SVG_ICON_COLORS = {}));
exports.ELEVATIONS = void 0;
(function (ELEVATIONS) {
    ELEVATIONS[ELEVATIONS["ZERO"] = 0] = "ZERO";
    ELEVATIONS[ELEVATIONS["ONE"] = 1] = "ONE";
    ELEVATIONS[ELEVATIONS["TWO"] = 2] = "TWO";
    ELEVATIONS[ELEVATIONS["THREE"] = 3] = "THREE";
    ELEVATIONS[ELEVATIONS["FOUR"] = 4] = "FOUR";
    ELEVATIONS[ELEVATIONS["FIVE"] = 5] = "FIVE";
    ELEVATIONS[ELEVATIONS["SIX"] = 6] = "SIX";
    ELEVATIONS[ELEVATIONS["SEVEN"] = 7] = "SEVEN";
    ELEVATIONS[ELEVATIONS["EIGHT"] = 8] = "EIGHT";
})(exports.ELEVATIONS || (exports.ELEVATIONS = {}));
exports.BUTTON_TYPES = void 0;
(function (BUTTON_TYPES) {
    BUTTON_TYPES["BUTTON"] = "button";
    BUTTON_TYPES["SUBMIT"] = "submit";
})(exports.BUTTON_TYPES || (exports.BUTTON_TYPES = {}));
exports.BUTTON_VARIANTS = void 0;
(function (BUTTON_VARIANTS) {
    BUTTON_VARIANTS["PRIMARY"] = "primary";
    BUTTON_VARIANTS["SECONDARY"] = "secondary";
    BUTTON_VARIANTS["INTERACTIVE"] = "interactive";
    BUTTON_VARIANTS["GHOST"] = "ghost";
})(exports.BUTTON_VARIANTS || (exports.BUTTON_VARIANTS = {}));
exports.BUTTON_SIZES = void 0;
(function (BUTTON_SIZES) {
    BUTTON_SIZES["SMALL"] = "small";
    BUTTON_SIZES["LARGE"] = "large";
})(exports.BUTTON_SIZES || (exports.BUTTON_SIZES = {}));
exports.TEXT_FIELD_TYPES = void 0;
(function (TEXT_FIELD_TYPES) {
    TEXT_FIELD_TYPES["PASSWORD"] = "password";
    TEXT_FIELD_TYPES["NUMBER"] = "number";
    TEXT_FIELD_TYPES["TEXT"] = "text";
    TEXT_FIELD_TYPES["EMAIL"] = "email";
})(exports.TEXT_FIELD_TYPES || (exports.TEXT_FIELD_TYPES = {}));
// master list = https://www.w3.org/TR/WCAG21/#input-purposes
exports.AUTOCOMPLETE_TYPES = void 0;
(function (AUTOCOMPLETE_TYPES) {
    AUTOCOMPLETE_TYPES["OFF"] = "turn-off";
    AUTOCOMPLETE_TYPES["NAME"] = "name";
    AUTOCOMPLETE_TYPES["HONORIFIC_PREFIX"] = "honorific-prefix";
    AUTOCOMPLETE_TYPES["GIVEN_NAME"] = "given-name";
    AUTOCOMPLETE_TYPES["ADDITIONAL_NAME"] = "additional-name";
    AUTOCOMPLETE_TYPES["FAMILY_NAME"] = "family-name";
    AUTOCOMPLETE_TYPES["HONORIFIC_SUFFIX"] = "honorific-suffix";
    AUTOCOMPLETE_TYPES["NICKNAME"] = "nickname";
    AUTOCOMPLETE_TYPES["ORGANIZATION_TITLE"] = "organization-title";
    AUTOCOMPLETE_TYPES["USERNAME"] = "username";
    AUTOCOMPLETE_TYPES["NEW_PASSWORD"] = "new-password";
    AUTOCOMPLETE_TYPES["CURRENT_PASSWORD"] = "current-password";
    AUTOCOMPLETE_TYPES["ORGANIZATION"] = "organization";
    AUTOCOMPLETE_TYPES["STREET_ADDRESS"] = "street-address";
    AUTOCOMPLETE_TYPES["ADDRESS_LINE1"] = "address-line1";
    AUTOCOMPLETE_TYPES["ADDRESS_LINE2"] = "address-line2";
    AUTOCOMPLETE_TYPES["ADDRESS_LINE3"] = "address-line3";
    AUTOCOMPLETE_TYPES["ADDRESS_LEVEL1"] = "address-level1";
    AUTOCOMPLETE_TYPES["ADDRESS_LEVEL2"] = "address-level2";
    AUTOCOMPLETE_TYPES["ADDRESS_LEVEL3"] = "address-level3";
    AUTOCOMPLETE_TYPES["ADDRESS_LEVEL4"] = "address-level4";
    AUTOCOMPLETE_TYPES["COUNTRY"] = "country";
    AUTOCOMPLETE_TYPES["COUNTRY_NAME"] = "country-name";
    AUTOCOMPLETE_TYPES["POSTAL_CODE"] = "postal-code";
    AUTOCOMPLETE_TYPES["CC_NAME"] = "cc-name";
    AUTOCOMPLETE_TYPES["CC_GIVEN_NAME"] = "cc-given-name";
    AUTOCOMPLETE_TYPES["CC_ADDITIONAL_NAME"] = "cc-additional-name";
    AUTOCOMPLETE_TYPES["CC_FAMILY_NAME"] = "cc-family-name";
    AUTOCOMPLETE_TYPES["CC_NUMBER"] = "cc-number";
    AUTOCOMPLETE_TYPES["CC_EXP"] = "cc-exp";
    AUTOCOMPLETE_TYPES["CC_EXP_MONTH"] = "cc-exp-month";
    AUTOCOMPLETE_TYPES["CC_EXP_YEAR"] = "cc-exp-year";
    AUTOCOMPLETE_TYPES["CC_CSC"] = "cc-csc";
    AUTOCOMPLETE_TYPES["CC_TYPE"] = "cc-type";
    AUTOCOMPLETE_TYPES["TRANSACTION_CURRENCY"] = "transaction-currency";
    AUTOCOMPLETE_TYPES["TRANSACTION_AMOUNT"] = "transaction-amount";
    AUTOCOMPLETE_TYPES["LANGUAGE"] = "language";
    AUTOCOMPLETE_TYPES["BDAY"] = "bday";
    AUTOCOMPLETE_TYPES["BDAY_DAY"] = "bday-day";
    AUTOCOMPLETE_TYPES["BDAY_MONTH"] = "bday-month";
    AUTOCOMPLETE_TYPES["BDAY_YEAR"] = "bday-year";
    AUTOCOMPLETE_TYPES["SEX"] = "sex";
    AUTOCOMPLETE_TYPES["URL"] = "url";
    AUTOCOMPLETE_TYPES["PHOTO"] = "photo";
    AUTOCOMPLETE_TYPES["TEL"] = "tel";
    AUTOCOMPLETE_TYPES["TEL_COUNTRY_CODE"] = "tel-country-code";
    AUTOCOMPLETE_TYPES["TEL_NATIONAL"] = "tel-national";
    AUTOCOMPLETE_TYPES["TEL_AREA_CODE"] = "tel-area-code";
    AUTOCOMPLETE_TYPES["TEL_LOCAL"] = "tel-local";
    AUTOCOMPLETE_TYPES["TEL_LOCAL_PREFIX"] = "tel-local-prefix";
    AUTOCOMPLETE_TYPES["TEL_LOCAL_SUFFIX"] = "tel-local-suffix";
    AUTOCOMPLETE_TYPES["TEL_EXTENSION"] = "tel-extension";
    AUTOCOMPLETE_TYPES["EMAIL"] = "email";
    AUTOCOMPLETE_TYPES["IMPP"] = "impp";
})(exports.AUTOCOMPLETE_TYPES || (exports.AUTOCOMPLETE_TYPES = {}));
exports.TOOLTIP_PLACEMENTS = void 0;
(function (TOOLTIP_PLACEMENTS) {
    TOOLTIP_PLACEMENTS["TOP"] = "top";
    TOOLTIP_PLACEMENTS["BOTTOM"] = "bottom";
    TOOLTIP_PLACEMENTS["LEFT"] = "left";
    TOOLTIP_PLACEMENTS["RIGHT"] = "right";
})(exports.TOOLTIP_PLACEMENTS || (exports.TOOLTIP_PLACEMENTS = {}));
exports.SNACKBAR_VARIANTS = void 0;
(function (SNACKBAR_VARIANTS) {
    SNACKBAR_VARIANTS["PLAIN"] = "plain";
    SNACKBAR_VARIANTS["SUCCESS"] = "success";
    SNACKBAR_VARIANTS["ERROR"] = "error";
    SNACKBAR_VARIANTS["WARNING"] = "warning";
    SNACKBAR_VARIANTS["DOWNLOAD"] = "download";
})(exports.SNACKBAR_VARIANTS || (exports.SNACKBAR_VARIANTS = {}));
exports.MENU_HORIZONTAL_ALIGNMENTS = void 0;
(function (MENU_HORIZONTAL_ALIGNMENTS) {
    MENU_HORIZONTAL_ALIGNMENTS["LEFT"] = "left";
    MENU_HORIZONTAL_ALIGNMENTS["RIGHT"] = "right";
})(exports.MENU_HORIZONTAL_ALIGNMENTS || (exports.MENU_HORIZONTAL_ALIGNMENTS = {}));
exports.STEPPER_STATUS = void 0;
(function (STEPPER_STATUS) {
    STEPPER_STATUS["ACTIVE"] = "active";
    STEPPER_STATUS["INACTIVE"] = "inactive";
    STEPPER_STATUS["COMPLETED"] = "completed";
})(exports.STEPPER_STATUS || (exports.STEPPER_STATUS = {}));
